import type { LucideIcon } from 'lucide-react';

interface UserRowActionButtonProps {
  icon: LucideIcon;
  label: string;
  /** Hover explanation, since the label has to stay short. */
  title?: string;
  tone?: 'default' | 'danger';
  onClick: () => void;
}

const TONE_CLASS = {
  default: 'text-moss-700 dark:text-moss-200 hover:bg-moss-50 dark:hover:bg-moss-900/20',
  danger: 'text-clay-700 dark:text-clay-300 hover:bg-clay-50 dark:hover:bg-clay-900/20',
} as const;

/** Compact inline action for a table row, whose click does not select it. */
export default function UserRowActionButton({
  icon: Icon,
  label,
  title,
  tone = 'default',
  onClick,
}: UserRowActionButtonProps) {
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      title={title}
      className={`inline-flex items-center gap-1.5 h-7 px-2.5 mr-1.5 rounded-lg border border-stone-200 dark:border-stone-800 bg-white dark:bg-[#1a1f1c] text-[12px] font-semibold ${TONE_CLASS[tone]}`}
    >
      <Icon size={12} />
      {label}
    </button>
  );
}
